<template>
  <section>
    <div v-show="isValidToken && !isLoading" class="hero">
      <div class="hero-body is-full">
        <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
        <inventory-information :supplier="supplier" :inventoryItem="inventoryItem" :inventorySalesVideoId="inventorySalesVideoId" :attachmentMediaIds="attachmentMediaIds"></inventory-information>
      </div>
    </div>
    <div v-show="!isValidToken && isLoading" class="hero">
      <div class="hero-body container">
        <div class="container is-fluid">
          <div class="columns is-vcentered loadingContainer">
            <div class="column is-12 has-text-centered has-text-weight-semi-bold">
              <img src="@/assets/ajax-loader.gif">
              <div v-if="loadingBaseData">Loading data....</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isValidToken && invalidTokenProvided" class="hero">
      <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="token-error-container"></error-display-component>
    </div>
  </section>
</template>

<script>
import InventoryInformation from '@/components/generic/InventoryInformation'
import inventoryService from '@/services/inventoryService'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
export default {
  components: {
    'inventory-information': InventoryInformation,
    'error-display-component': ErrorDisplayComponent
  },
  data () {
    return {
      supplier: null,
      inventoryItem: null,
      isLoading: false,
      isValidToken: false,
      serverErrors: [],
      serverErrorMessage: '',
      loadingBaseData: false,
      invalidTokenProvided: false,
      inventorySalesVideoId: 0,
      attachmentMediaIds: ''
    }
  },
  created () {
    this.$emit('is-home', false)
  },
  mounted () {
    this.$emit('set-title-one', 'VEHICLE')
    this.$emit('set-title-two', 'INFORMATION')
    const queryToken = this.$route.query.token
    if (this.token) {
      this.fetchSupplierVehicleInformation(this.token)
    } else if (queryToken) {
      this.fetchSupplierVehicleInformation(queryToken)
    } else {
      this.serverErrorMessage = 'Invalid or no authentication token provided'
      this.invalidTokenProvided = true
    }
  },
  watch: {
    token: function (newValue, oldValue) {
      this.isValidToken = false
      if (newValue) {
        this.fetchSupplierVehicleInformation(this.token)
      }
    }
  },
  methods: {
    fetchSupplierVehicleInformation: function (currentToken) {
      this.serverErrorMessage = ''
      this.loadingBaseData = true
      this.isLoading = true
      inventoryService.getSupplierInventoryInformation(currentToken).then(response => {
        this.supplier = {
          ...response.supplier
        }
        this.inventoryItem = {
          ...response.inventory
        }
        this.inventorySalesVideoId = response.inventorySalesVideoId
        this.attachmentMediaIds = response.attachmentMediaIds
        this.isValidToken = true
        this.isLoading = false
        this.loadingBaseData = false
      }).catch((error) => {
        this.isLoading = false
        this.loadingBaseData = false
        this.serverErrorMessage = 'Could not load vehicle information: ' + currentToken
        this.isValidToken = false
        console.log(error)
      })
    },
    resetValues () {
      this.supplier = null
      this.inventoryItem = null
    }
  }
}
</script>
